// src/components/common/HeroBanner.js
import React from 'react';
import { Box, Typography } from '@mui/material';

// HomePage의 풀와이드 히어로 섹션과 같은 톤을 유지하는 공통 배너
// image가 없거나 로드 실패해도 어두운 단색 배경으로 자연스럽게 대체됩니다.
const HeroBanner = ({ image, title, tagline }) => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      height: { xs: 220, md: 320 },
      backgroundImage: image ? `url(${image})` : 'none',
      backgroundColor: '#1f2937',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'flex-end',
      overflow: 'hidden'
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(180deg, rgba(0,0,0,0) 35%, rgba(0,0,0,0.72) 100%)'
      }}
    />
    <Box sx={{ position: 'relative', p: { xs: 3, md: 5 }, color: 'white' }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{ fontWeight: 'bold', mb: 1, textShadow: '1px 1px 6px rgba(0,0,0,0.6)' }}
      >
        {title}
      </Typography>
      <Typography variant="body1" sx={{ textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}>
        {tagline}
      </Typography>
    </Box>
  </Box>
);

export default HeroBanner;
